/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

import { CommonAPI } from '../common/responses';
import { ParticipantAPI } from './types';

const baseUrl = `/api/internal`;

export const callsClient = (request: AxiosInstance) => ({
  async fetchCallUserData(callId: string): Promise<CommonAPI.UserDataResponse> {
    return (await request.get(`${baseUrl}/calls/${callId}/user-data`)).data;
  },

  async createParticipantFeedback(callId: string, body: ParticipantAPI.CreateFeedbackRequestBody) {
    return await request.post(`${baseUrl}/calls/${callId}/create-feedback`, { ...body });
  },
});
